import "./App.css";
import HomePage from "./Pages/HomePage";
import AboutUs from "./Pages/AboutUs";
import Products from "./Pages/Products";
import ContactUs from "./Pages/ContactUs";
import EmiWithBank from "./Pages/EmiWithBank";
import SignIn from "./Pages/SignIn";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SignUp from "./Pages/signUp";
import Blog from "./Pages/Blog"
import BlogPost from "./Pages/BlogPost";
import EmiRegister from "./Pages/EmiRegister";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions";
import Help from "./Pages/Help";
import CheckStatus from "./Pages/CheckStatus";
import CancelEmi from "./Pages/CancelEmi";
import AdminDashboard from "./Pages/AdminDashboard";
import Login from "./Pages/Login";
import Profile from "./Pages/Profile";
import NotFound from './Pages/NotFound';
import CustomerEnquiry from './Pages/CustomerEnquiry';

import GiroStatusPage from './Components/Shared/GiroStatus';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/our-story" element={<AboutUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/dbs-emi" element={<EmiWithBank />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/emi-registration" element={<EmiRegister />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/help" element={<Help />} />
          <Route path="/application-status" element={<CheckStatus />} />
          <Route path="/cancel-emi" element={<CancelEmi />} />
          {/* <Route path="/dashboard" element={<AdminDashboard />} /> */}
          <Route path="/login" element={<Login />} />
          <Route path="/personal" element={<Profile />} />
          <Route path="/status" element={<GiroStatusPage />} />
          <Route path="/bo-redirect/cancellation" element={<GiroStatusPage />} />
          <Route path="/customers" element={<AdminDashboard />} />
          <Route path="/products-list" element={<AdminDashboard />} />
          <Route path="/user" element={<AdminDashboard />} />
          <Route path="/access" element={<AdminDashboard />} />
          <Route path="/activity" element={<AdminDashboard />} />
          <Route path="/reset-password" element={<AdminDashboard />} />
          <Route path="/reports" element={<AdminDashboard />} />
          <Route path="/collection" element={<AdminDashboard />} />
          <Route path="/application" element={<AdminDashboard />} />
          <Route path="/processing-fee" element={<AdminDashboard />} />
          <Route path="/customer-enquiry" element={<CustomerEnquiry />} />
          <Route
            path="*"
            element={
              <NotFound />
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
